export default "__VITE_ASSET__BcRxRQPR__"